import approvalRequestsService from "../../../../services/procurementService/approvalRequestsService";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_APPROVALREQUESTS } from "../../../../utils/constants";
import { ApprovalRequestInterface } from "../../../../models/ProcurementModule/ApprovalRequest";

const useApprovalRequests = () =>
  useQuery<ApprovalRequestInterface[], Error>({
    queryKey: [CACHE_KEY_APPROVALREQUESTS],
    queryFn: () => approvalRequestsService.GetMyApprovalRequests(),
    initialData: [],
  });

export default useApprovalRequests;
